module.exports = __webpack_public_path__ + "static/img/salesPlatform2.0d58675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/salesPlatform2.png
// module id = S5JP
// module chunks = 1